<template>
    <div class="form-group">
        <div class="form-group row">
            <div class="col-8">
                <input type="hidden" value="0" name="skip_address" />
                <!-- <input type="checkbox" value="1" name="skip_address" id="skip_address" {{ old('skip_address') == 1 ? 'checked' : '' }} /> -->
                <input type="checkbox" value="1" name="skip_address" id="skip_address" v-model="skip_address" />
                <label for="skip_address">Bestelling vanuit Boekencafé (zonder adres)</label>
            </div>
        </div>

        <div class="form-group row" v-if="skip_address">
            <div class="col-md-2 pr-0">
                <label for="first_name">Voornaam (*)</label>
                <!-- <input type="text" class="form-control" name="first_name" autocomplete="off" placeholder="{{ __('debtor.contact.field.first_name.label') }}" value="{{ old('first_name') }}" /> -->
                <input type="text" class="form-control" name="first_name" autocomplete="off" placeholder="Voornaam" :value="first_name" />
            </div>
            <div class="col-md-2 pr-0">
                <label for="insertion">Tussenvoegsel</label>
                <!-- <input type="text" class="form-control" name="insertion" autocomplete="off" placeholder="{{ __('debtor.contact.field.insertion.label') }}" value="{{ old('insertion') }}" /> -->
                <input type="text" class="form-control" name="insertion" autocomplete="off" placeholder="Tussenvoegsel" :value="insertion" />
            </div>
            <div class="col-md-2">
                <label for="last_name">Achternaam (*)</label>
                <!-- <input type="text" class="form-control" name="last_name" autocomplete="off" placeholder="{{ __('debtor.contact.field.last_name.label') }}" value="{{ old('last_name') }}" /> -->
                <input type="text" class="form-control" name="last_name" autocomplete="off" placeholder="Achternaam" :value="last_name" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        oldSkipAddress: {
            required: false,
            type: Boolean
        },
        oldFirstName: {
            required: false,
            type: String
        },
        oldInsertion: {
            required: false,
            type: String
        },
        oldLastName: {
            required: false,
            type: String
        },
    },
    data: function () {
        return {
            skip_address: this.oldSkipAddress,
            first_name: this.oldFirstName,
            insertion: this.oldInsertion,
            last_name: this.oldLastName,
        }
    },
    watch: {
        skip_address: function (newValue) {
            if(newValue){
                $("select[name='delivery_method']").find("option[value='1']").hide();
                $("select[name='delivery_method']").find("option[value='2']").hide();
                $("select[name='delivery_method']").val(3);
            }
            else{
                $("select[name='delivery_method']").find("option[value='1']").show();
                $("select[name='delivery_method']").find("option[value='2']").show();
                $("select[name='delivery_method']").val(1);
            }
        }
    }
}
</script>
